<ul>
  @for (unitType of unitTypes; track unitType) {
    @let filteredUnits = eligibleUnits() | filterByUnitType: unitType;

    @if(filteredUnits.length > 0) {
      <li>
        <p>
          {{ unitType | unitTypeToText }}: {{ 'common.price.seniorIncomeBased' | transloco }}
        </p>
      </li>
    }
  }
</ul>
